// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rpGJjwP1NWYcFzuTeQHC{flex-grow:1;display:flex;position:relative;overflow:auto}.MWyuDXHWmlwe4NT3ehrR:first-letter{text-transform:uppercase}.d7gKBTSRs4Ag3TWCR8cD{width:144px}.d7gKBTSRs4Ag3TWCR8cD .xkzBjAieloY7EKwht1sC{white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.beJ3MhZHhb0ZM5nNlGi_{border:1px solid var(--black-10);background:var(--black-20);color:var(--gray-80);border-radius:4px;align-items:center;padding:1px 4px 2px;display:flex}.D6m5_I8DagFbnrRjugMF{position:relative}.emSJjgrUDqUEKtj0uDF9{width:-webkit-fit-content;width:fit-content;z-index:var(--zIndex-BASE_1);position:absolute;top:-12px;left:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableWrap": `rpGJjwP1NWYcFzuTeQHC`,
	"recordSource": `MWyuDXHWmlwe4NT3ehrR`,
	"userWrap": `d7gKBTSRs4Ag3TWCR8cD`,
	"user": `xkzBjAieloY7EKwht1sC`,
	"label": `beJ3MhZHhb0ZM5nNlGi_`,
	"audioWrap": `D6m5_I8DagFbnrRjugMF`,
	"audio": `emSJjgrUDqUEKtj0uDF9`
};
export default ___CSS_LOADER_EXPORT___;
